import React from "react";
import { Logo } from "@/components/Logo";

export const Footer = () => (
  <footer className="mt-24 border-t border-black/5 bg-white">
    <div className="max-w-7xl mx-auto px-6 py-12 grid gap-8 sm:grid-cols-3">
      <div>
        <div className="mb-3">
          <Logo size="sm" />
        </div>
        <p className="text-sm text-muted-foreground max-w-xs">
          Your Alanya activity companion — discover, book and enjoy the best tours and experiences.
        </p>
      </div>
      <div className="text-sm">
        <h4 className="font-semibold mb-3 font-display">Explore</h4>
        <ul className="space-y-2 text-muted-foreground">
          <li>Boat Tours</li><li>Watersports</li><li>Sightseeing</li><li>Adventure</li>
        </ul>
      </div>
      <div className="text-sm">
        <h4 className="font-semibold mb-3 font-display">Trust & Safety</h4>
        <ul className="space-y-2 text-muted-foreground">
          <li>Verified operators</li><li>Secure payments</li><li>Free cancellation</li><li>24/7 WhatsApp support</li>
        </ul>
      </div>
    </div>
    <div className="border-t border-black/5 py-4 text-center text-xs text-muted-foreground">
      © {new Date().getFullYear()} Go2Alanya. Made for travelers in Alanya, Turkey.
    </div>
  </footer>
);
